export default __webpack_public_path__ + "static/media/QuickTixMultiColor.6e4fe637.png";